export var WizardType;
(function (WizardType) {
    WizardType[WizardType["PANEL"] = 0] = "PANEL";
    WizardType[WizardType["FULL_PAGE"] = 1] = "FULL_PAGE";
    WizardType[WizardType["SETUP"] = 2] = "SETUP";
})(WizardType || (WizardType = {}));
//# sourceMappingURL=Wizard.types.js.map